var account = "Račun";
var accountSettings = "Nastavitve računa";
var charging = "Polnjenje";
var contactInfo = "Podatki za stik";
var dashboard = "Nadzorna plošča";
var home = "Domov";
var myProducts = "Moji izdelki";
var orderHistory = "Zgodovina naročila";
var paymentMethod = "Način plačila";
var profileSettings = "Nastavitve profila";
var referAndEarn = "Priporoči in pridobi";
var signOut = "Odjava";
var sl_SI = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, sl_SI as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
